export default function AppFooter() {
    return (
        <footer className="main-footer">
            <strong>Copyright &copy; 2025 <a href="/">Equipo de Victimas, Alcaldia de Medellin</a>. </strong>
            Todos los derechos reservados.
            <div className="float-right d-none d-sm-inline-block">
                <b>Version</b> 2.0
            </div>
        </footer>
    )
  }